import snappSound from "../../assets/sounds/snapp-bell.mp3";

const SoundEffect = {
    snappAudio: () => {
        return new Audio(snappSound);
    }
}

export default SoundEffect;